<template>
    <vx-card :title='$t("BranchOffices")' collapse-action>
        <div class="mt-6">
            <vs-table v-model="selected" @selected="handleSelected" :data="branchOfficesData">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <div class="flex flex-wrap-reverse items-center mb-3">
                        <vs-button v-if="$checkPermission(303)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addClientBranchOfficePrompt = true">{{$t("Add")}}</vs-button>
                    </div>

                </div>

                <template slot="thead">
                    <vs-th>{{$t("Title")}}</vs-th>
                    <vs-th>{{$t("Address")}}</vs-th>
                    <vs-th>{{$t("PostNumAddr")}}</vs-th>
                    <vs-th>{{$t("Town")}}</vs-th>
                    <vs-th>{{$t("Country")}}</vs-th>
                    <vs-th>{{$t("TransportType")}}</vs-th>
                    <vs-th>{{$t("BranchOfficeLocationValid")}}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

                        <vs-td :data="data[indextr].title">
                            {{data[indextr].title}}
                        </vs-td>
                        <vs-td :data="data[indextr].address">
                            {{data[indextr].address}}
                        </vs-td>
                        <vs-td :data="data[indextr].post_num_addr">
                            {{data[indextr].post_num_addr}}
                        </vs-td>
                        <vs-td :data="data[indextr].town">
                            {{data[indextr].town}}
                        </vs-td>
                        <vs-td :data="data[indextr].country">
                            {{data[indextr].country}}
                        </vs-td>
                        <vs-td :data="data[indextr].transport_type_name">
                            {{data[indextr].transport_type_name}}
                        </vs-td>
                        <vs-td v-if="data[indextr].map_location_valid">
                            <vs-chip color="success">
                                {{$t("Yes")}}
                            </vs-chip>
                        </vs-td>
                        <vs-td v-else>
                            <vs-chip color="danger">
                                {{$t("No")}}
                            </vs-chip>

                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </div>

        <vs-popup :title="$t('Add')" :active.sync="addClientBranchOfficePrompt">
            <div>
                <p class="mt-6">{{$t("Title")}}</p>
                <vs-input v-model="branchOfficeAdd['title']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Address")}}</p>
                <vs-input v-model="branchOfficeAdd['address']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("PostNumAddr")}}</p>
                <vs-input v-model="branchOfficeAdd['post_num_addr']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Town")}}</p>
                <vs-input v-model="branchOfficeAdd['town']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Country")}}</p>
                <vs-input v-model="branchOfficeAdd['country']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("TransportType")}}</p>
                <vs-select class="selectExample w-full" v-model="branchOfficeAdd['transport_type']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in transportTypes" />
                </vs-select>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addBranchOffice">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editClientBranchOfficePrompt">
            <div>
                <p class="mt-6">{{$t("Title")}}</p>
                <vs-input v-model="branchOfficeEdit['title']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Address")}}</p>
                <vs-input v-model="branchOfficeEdit['address']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("PostNumAddr")}}</p>
                <vs-input v-model="branchOfficeEdit['post_num_addr']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Town")}}</p>
                <vs-input v-model="branchOfficeEdit['town']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Country")}}</p>
                <vs-input v-model="branchOfficeEdit['country']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("TransportType")}}</p>
                <vs-select class="selectExample w-full" v-model="branchOfficeEdit['transport_type']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in transportTypes" />
                </vs-select>
                <vs-divider/>
                <vs-button style="float: left" id="saveBranchOfficeButton" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editBranchOffice">{{$t("Save")}}</vs-button>
                <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeBranchOffice">{{$t("Delete")}}</vs-button>
            </div>
        </vs-popup>

    </vx-card>
</template>
<script>

    export default {
        components: {
        },
        props: {
            clientId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {

                branchOffices: [],
                addClientBranchOfficePrompt: false,
                branchOfficeAdd: {},

                editClientBranchOfficePrompt: false,
                branchOfficeEdit: {},
                selected: {},

                transportTypes: [],

            }
        },
        computed: {
            transportTypeMap: function () {

                let types = {};
                for(let x = 0; x < this.transportTypes.length; x++){
                    types[this.transportTypes[x].id] = this.transportTypes[x];
                }
                return types

            },
          branchOfficesData: function () {
              let list = [];
              for(let x = 0; x < this.branchOffices.length; x++){
                  list.push(this.branchOffices[x]);
                  if (this.transportTypeMap[this.branchOffices[x].transport_type] !== undefined){
                      list[list.length-1].transport_type_name = this.transportTypeMap[this.branchOffices[x].transport_type].name
                  }

              }
              return list;
          }
        },
        watch: {
            editClientBranchOfficePrompt: function () {
                if(!this.editClientBranchOfficePrompt){
                    this.selected = {}
                }
            }
        },
        methods: {
            handleSelected(tr) {
                this.branchOfficeEdit = Object.assign({}, tr);
                this.editClientBranchOfficePrompt = true;
            },
            isPromptOpen() {
                return this.addClientBranchOfficePrompt || this.editClientBranchOfficePrompt;
            },
            closePrompts(){
                this.addClientBranchOfficePrompt = false;
                this.editClientBranchOfficePrompt = false;
            },
            updateClientBranchOffices() {
                const thisIns = this;
                this.$http.get('/api/v1/client/' + this.clientId + '/branch_offices')
                    .then(function (response) {
                        thisIns.branchOffices = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addBranchOffice() {
                const thisIns = this;
                this.$http.post('/api/v1/client/' + this.clientId + '/branch_offices', this.branchOfficeAdd)
                .then(function () {
                    thisIns.updateClientBranchOffices();
                    thisIns.addClientBranchOfficePrompt = false;
                    thisIns.branchOfficeAdd = {};
                    thisIns.branchOfficeAdd.transport_type = thisIns.transportTypes[0].id
                }).catch(function (error) {
                    thisIns.addClientBranchOfficePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editBranchOffice(){
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#saveBranchOfficeButton",
                    scale: 0.45
                });
                const thisIns = this;
                this.$http.put('/api/v1/client/' + this.clientId + '/branch_offices/' + this.selected.id, this.branchOfficeEdit)
                    .then(function () {
                        thisIns.$vs.loading.close("#saveBranchOfficeButton > .con-vs-loading");
                        thisIns.updateClientBranchOffices();
                        thisIns.editClientBranchOfficePrompt = false;
                    }).catch(function (error) {
                    thisIns.$vs.loading.close("#saveBranchOfficeButton > .con-vs-loading");
                    thisIns.editClientBranchOfficePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeBranchOffice(){
                const thisIns = this;
                this.$http.delete('/api/v1/client/' + this.clientId + '/branch_offices/' + this.selected.id)
                    .then(function () {
                        thisIns.updateClientBranchOffices();
                        thisIns.editClientBranchOfficePrompt = false;
                    }).catch(function (error) {
                    thisIns.editClientBranchOfficePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        created() {
            this.updateClientBranchOffices();
            const thisIns = this;

            this.$http.get('/api/v1/transport_type/')
                .then(function (response) {
                    thisIns.transportTypes = response.data;
                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
        },
    }

</script>
